import classNames from 'classnames';
import type { CSSProperties, FC } from 'react';
import { Link } from 'wouter';

import Icon from 'components/Icon/Icon';
import type { ActionButton } from 'config/types';
import { getMediaUrl } from 'utils/assets';
import useLayout, { LayoutType } from 'utils/layout';
import { Translation } from 'utils/translations';

import styles from './ActionButtons.module.scss';

type ActionButtonsProps = {
  buttons: [ActionButton, ActionButton];
};

const ActionButtons: FC<ActionButtonsProps> = ({ buttons }) => {
  const layout = useLayout();
  const iconSize = layout === LayoutType.mobile ? 24 : 32;

  return (
    <div className={classNames(styles.wrapper, styles[layout])}>
      {buttons.map(({ label, link, color, image }) => (
        <Link
          key={link}
          to={link}
          className={styles.button}
          style={{ '--color': color } as CSSProperties}
        >
          <img
            className={styles.img}
            src={getMediaUrl(image, 'cms')}
            alt={label}
          />
          <div className={styles.label}>
            <Translation message={label} />
          </div>
          <Icon
            name="arrow-right.circle"
            width={iconSize}
            height={iconSize}
            className={styles.icon}
          />
        </Link>
      ))}
    </div>
  );
};

export default ActionButtons;
